import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { LoadScript } from '@react-google-maps/api';
import initAuth0 from '@/shared/components/account/auth/withAuth0';
import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';
import Loading from '@/shared/components/Loading';
import WalletConnectProvider from '@/shared/components/account/auth/WalletConnect';
import { Toaster } from 'react-hot-toast';
import CryptoJS from 'crypto-js';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import GlobalStyles from './globalStyles';
import RechartStyles from './rechartStyles';
import NotificationStyles from './notificationStyles';
import CalendarStyles from './calendarStyles';
import { AuthContext } from '../../context/AuthContext'; // Ensure correct path
import { PermissionContext } from '../../context/PermissionContext';
import AppContextProvider from '../../context';
import { GlobalVarContext } from '../../context/GlobalVarContext';
import Chatbot from './Chatbot';
import Footer from '../Restau/Footer/Footer';

i18n.init(i18nextConfig);

const ThemeComponent = ({ children }) => {
  const {
    mode, direction, shadow, border,
  } = useSelector(state => ({
    mode: state.theme.className,
    direction: state.rtl.direction,
    shadow: state.shadow.className,
    border: state.border.className,
  }));

  const theme = createTheme({
    palette: {
      type: mode,
    },
  });

  const {
 userid, setUserId, username, 
    setUsername, setCurrencyCode, currencyCode, 
    setStatusCode, setRestaurantId, setType, statusCode, restaurantid, type, countryId, setCountryId,
} = useContext(AuthContext);
  const { setPermissionsAccess, permissionUpdate } = useContext(PermissionContext);
  const { apiGlobal } = useContext(GlobalVarContext);

  useEffect(() => {
    const navigationEntries = performance.getEntriesByType('navigation');
    const navigationType = navigationEntries.length > 0 ? navigationEntries[0].type : 'navigate';
 
    if (navigationType === 'reload') {
      const encryptedPermissions = localStorage.getItem('respermissions');
      if (encryptedPermissions) {
        try {
          const bytes = CryptoJS.AES.decrypt(
            encryptedPermissions,
            'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
          );
          const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);
 
          if (decryptedPermissionsString) {
            const permissionsAccess = JSON.parse(decryptedPermissionsString);
            setPermissionsAccess(permissionsAccess);
          }
        } catch (error) {
          console.error('Decryption error:', error);
        }
      }
    } else {
      console.log('Page was loaded normally');
    }
  }, []);

  // const fetchPermissions = async () => {
  //   try {
  //     const response = await fetch(`${apiGlobal}/restaurant/restaurant_permission.php?id=${userid}`);
  //     const data = await response.json();

  //     if (data.status && data.message === 'Success') {
  //       const permissions = data.data[0].permission;
  //       setPermissionsAccess(permissions);
  //       const encryptedPermissions = CryptoJS.AES.encrypt(
  //         JSON.stringify(permissions), 
  //         'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
  //       ).toString();
  //       localStorage.setItem('permissions', encryptedPermissions);
  //     } else {
  //       setPermissionsAccess([]);
  //       localStorage.removeItem('permissions');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching permissions:', error);
  //     setPermissionsAccess([]);
  //     localStorage.removeItem('permissions');
  //   }
  // };

  // useEffect(() => {
  //   const encryptedPermissions = localStorage.getItem('permissions');
  //   if (userid) {
  //     fetchPermissions();
  //   } else if (encryptedPermissions) {
  //     const bytes = CryptoJS.AES.decrypt(encryptedPermissions, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //     const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);
  //     if (decryptedPermissionsString) {
  //       const permissionsAccess = JSON.parse(decryptedPermissionsString);
  //       setPermissionsAccess(permissionsAccess);
  //     }
  //   }
  // }, [userid, permissionUpdate]);

  useEffect(() => {
    if (!userid) {
      const encryptedData = localStorage.getItem('resuserid');
      if (encryptedData) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
        setUserId(decryptedUserId);
      }
    }
  }, [userid]);

  useEffect(() => {
    if (!username) {
      const encryptedData = localStorage.getItem('resuserName');
      if (encryptedData) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const decryptedUserName = bytes.toString(CryptoJS.enc.Utf8);
        setUsername(decryptedUserName);
      }
    }
  }, [username]);

  useEffect(() => {
    if (!username) {
      const encryptedData = localStorage.getItem('99117114114101110991219599111100101');
      if (encryptedData) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const decryptedCurrencyCode = bytes.toString(CryptoJS.enc.Utf8);
        setCurrencyCode(decryptedCurrencyCode);
      }
    }
  }, [currencyCode]);



  useEffect(() => {
      // Decrypt and retrieve the user ID from localStorage only once when the component mounts
      const encryptedData = localStorage.getItem('resuserid');
      const encryptedStatusCode = localStorage.getItem('resstatuscode');
      const encryptedResID = localStorage.getItem('restauresID');
      const encryptedType = localStorage.getItem('restype');
      const encryptedCountryID = localStorage.getItem('cid');

      if (encryptedData && encryptedStatusCode && encryptedResID && encryptedType && encryptedCountryID) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const bytes1 = CryptoJS.AES.decrypt(encryptedStatusCode, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const bytes2 = CryptoJS.AES.decrypt(encryptedResID, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const bytes3 = CryptoJS.AES.decrypt(encryptedType, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const bytes4 = CryptoJS.AES.decrypt(encryptedCountryID, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
        const decryptedStatusCode = bytes1.toString(CryptoJS.enc.Utf8);
        const decryptedResID = bytes2.toString(CryptoJS.enc.Utf8);
        const decryptedType = bytes3.toString(CryptoJS.enc.Utf8);
        const decryptedCountryId = bytes4.toString(CryptoJS.enc.Utf8);
        setUserId(decryptedUserId);
        setStatusCode(decryptedStatusCode);
        setRestaurantId(decryptedResID);
        setType(decryptedType);
        setCountryId(decryptedCountryId);
      }
    }, [statusCode, userid, restaurantid, type, countryId]); // Empty dependency array ensures this runs only onces


  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={{ 
        mode, 
        direction, 
        shadow, 
        border,
         }}
      >
        <GlobalStyles />
        <NotificationStyles />
        <RechartStyles />
        <TimepickerStyles />
        <CalendarStyles />
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

const ConnectedThemeComponent = ThemeComponent;

const App = () => {
  useEffect(() => {
    window.addEventListener('load', initAuth0);
    return () => window.removeEventListener('load', initAuth0);
  }, []);

  return (
    <AppContextProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ConnectedThemeComponent>
            <LoadScript loadingElement={<Loading loading />} googleMapsApiKey="">
              <ScrollToTop>
                <Router />
                {/* <Chatbot />✅ Chatbot only when logged in */}
                <Toaster position="top-right" reverseOrder={false} />
              </ScrollToTop>
              <Footer />
            </LoadScript>
          </ConnectedThemeComponent>
        </BrowserRouter>
      </Provider>
    </AppContextProvider>
  );
};

export default App;


// import React, { useEffect, useContext } from 'react';
// import PropTypes from 'prop-types';
// import { ThemeProvider } from 'styled-components';
// import { Provider, useSelector } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
// import { I18nextProvider } from 'react-i18next';
// import i18n from 'i18next';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
// import { LoadScript } from '@react-google-maps/api';
// import initAuth0 from '@/shared/components/account/auth/withAuth0';
// import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';
// import Loading from '@/shared/components/Loading';
// import WalletConnectProvider from '@/shared/components/account/auth/WalletConnect';
// import { Toaster } from 'react-hot-toast';
// import CryptoJS from 'crypto-js';
// import Router from './Router';
// import store from './store';
// import ScrollToTop from './ScrollToTop';
// import { config as i18nextConfig } from '../../translations';
// import GlobalStyles from './globalStyles';
// import RechartStyles from './rechartStyles';
// import NotificationStyles from './notificationStyles';
// import CalendarStyles from './calendarStyles';
// import { AuthContext } from '../../context/AuthContext';
// import { PermissionContext } from '../../context/PermissionContext';
// import AppContextProvider from '../../context';
// import { GlobalVarContext } from '../../context/GlobalVarContext';
// import Chatbot from './Chatbot';

// i18n.init(i18nextConfig);

// const ThemeComponent = ({
//   children,
// }) => {
//   const {
//     mode, direction, shadow, border,
//   } = useSelector(state => ({
//     mode: state.theme.className,
//     direction: state.rtl.direction,
//     shadow: state.shadow.className,
//     border: state.border.className,
//   }));

//   const theme = createTheme({
//     palette: {
//       type: mode,
//     },
//   });

//   const { userId, setUserId } = useContext(AuthContext);
//   const { setPermissionsAccess, permissionUpdate } = useContext(PermissionContext);
//   const { apiGlobal } = useContext(GlobalVarContext);

//   const fetchPermissions = async () => {
//     try {
//       const response = await fetch(`${apiGlobal}/restaurant/restaurant_permission.php?id=${userId}`);
//       const data = await response.json();

//       console.log('Fetched Permissions:', data);
//       if (data.status && data.message === 'Success') {
//         const permissions = data.data[0].permission;
//         setPermissionsAccess(permissions);
//         const permissionsString = JSON.stringify(permissions);
//         console.log(permissionsString);
//         const encryptedPermissions = CryptoJS.AES
//         .encrypt(permissionsString, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2').toString();
//         localStorage.setItem('permissions', encryptedPermissions);
//         console.log(encryptedPermissions);
//         console.log('fetch permisssion function called');
//       } else {
//         setPermissionsAccess([]);
//         localStorage.removeItem('permissions');
//       }
//     } catch (error) {
//       console.error('Error fetching permissions:', error);
//       setPermissionsAccess([]);
//       localStorage.removeItem('permissions');
//     }
//   };

//   useEffect(() => {
//     const encryptedPermissions = localStorage.getItem('permissions');
   
//     if (userId) {
//       console.log('No stored permissions, fetching from API');
//       fetchPermissions();
//     } else if (encryptedPermissions) {
//       console.log('Loaded encrypted permissions from localStorage');
//       const bytes = CryptoJS.AES
//       .decrypt(encryptedPermissions, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
//       const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);
    
//       if (decryptedPermissionsString) {
//         const permissionsAccess = JSON.parse(decryptedPermissionsString);
//         console.log('Decrypted permissions:', permissionsAccess);
//         setPermissionsAccess(permissionsAccess);
//       } else {
//         console.log('Failed to decrypt permissions');
//       }
//     } else {
//       console.log('No permissions found in localStorage');
//     }

//     // if (storedPermissions) {
//     //   console.log('Loaded permissions from localStorage');
//     //   setPermissionsAccess(JSON.parse(storedPermissions));
//     // } else if (userid) {
//     //   console.log('No stored permissions, fetching from API');
//     //   fetchPermissions();
//     // }
//   }, [userId, permissionUpdate]);

//   useEffect(() => {
//     if (!userId) { // Only run the effect if userId is not set yet
//       // Decrypt and retrieve the user ID from localStorage
//       const encryptedData = localStorage.getItem('userid');
//       if (encryptedData) {
//         const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
//         const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
//         setUserId(decryptedUserId); // Set the userId state
//       }
//     }
//   }, [userId]); // Only run the effect when userId is null or undefineds
 


//   return (
//     <MuiThemeProvider theme={theme}>
//       <ThemeProvider
//         theme={{
//           mode,
//           direction,
//           shadow,
//           border,
//         }}
//       >
//         <GlobalStyles />
//         <NotificationStyles />
//         <RechartStyles />
//         <TimepickerStyles />
//         <CalendarStyles />
//         {children}
//       </ThemeProvider>
//     </MuiThemeProvider>
//   );
// };

// ThemeComponent.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// const ConnectedThemeComponent = ThemeComponent;

// const App = () => {
// // const { isLoggedIn } = useContext(AuthContext);
 

//   useEffect(() => {
//     window.addEventListener('load', initAuth0);
//   }, []);
   
  
// // basename="/bitVise"
//   return (
//     <AppContextProvider>
//       <Provider store={store}>
//         <BrowserRouter>
//           <ConnectedThemeComponent>
//             <LoadScript
//               loadingElement={<Loading loading />}
//               googleMapsApiKey=""
//             >
//               <Chatbot />
              
//               <ScrollToTop>
//                 <Router />
//                 <Toaster position="top-right" reverseOrder={false} />
//               </ScrollToTop>
//             </LoadScript>
//           </ConnectedThemeComponent>
//         </BrowserRouter>
//       </Provider>
//     </AppContextProvider>
    
//   );
// };

// export default App;


// import React, { useEffect, useContext } from 'react';
// import PropTypes from 'prop-types';
// import { ThemeProvider } from 'styled-components';
// import { Provider, useSelector } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
// import { I18nextProvider } from 'react-i18next';
// import i18n from 'i18next';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
// import { LoadScript } from '@react-google-maps/api';
// import initAuth0 from '@/shared/components/account/auth/withAuth0';
// import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';
// import Loading from '@/shared/components/Loading';
// import WalletConnectProvider from '@/shared/components/account/auth/WalletConnect';
// import { Toaster } from 'react-hot-toast';
// import CryptoJS from 'crypto-js';
// import Router from './Router';
// import store from './store';
// import ScrollToTop from './ScrollToTop';
// import { config as i18nextConfig } from '../../translations';
// import GlobalStyles from './globalStyles';
// import RechartStyles from './rechartStyles';
// import NotificationStyles from './notificationStyles';
// import CalendarStyles from './calendarStyles';
// import { AuthContext } from '../../context/AuthContext';
// import { PermissionContext } from '../../context/PermissionContext';
// import AppContextProvider from '../../context';
// import { GlobalVarContext } from '../../context/GlobalVarContext';
// import Chatbot from './Chatbot';

// i18n.init(i18nextConfig);

// const ThemeComponent = ({ children }) => {
//   const {
//     mode, direction, shadow, border,
//   } = useSelector(state => ({
//     mode: state.theme.className,
//     direction: state.rtl.direction,
//     shadow: state.shadow.className,
//     border: state.border.className,
//   }));

//   const theme = createTheme({
//     palette: {
//       type: mode,
//     },
//   });

//   const { userId, setUserId, isLoggedIn } = useContext(AuthContext);
//   const { setPermissionsAccess, permissionUpdate } = useContext(PermissionContext);
//   const { apiGlobal } = useContext(GlobalVarContext);

//   const fetchPermissions = async () => {
//     try {
//       const response = await fetch(`${apiGlobal}/restaurant/restaurant_permission.php?id=${userId}`);
//       const data = await response.json();

//       if (data.status && data.message === 'Success') {
//         const permissions = data.data[0].permission;
//         setPermissionsAccess(permissions);
//         const encryptedPermissions = CryptoJS.AES.encrypt(
//           JSON.stringify(permissions), 
//           'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
//         ).toString();
//         localStorage.setItem('permissions', encryptedPermissions);
//       } else {
//         setPermissionsAccess([]);
//         localStorage.removeItem('permissions');
//       }
//     } catch (error) {
//       console.error('Error fetching permissions:', error);
//       setPermissionsAccess([]);
//       localStorage.removeItem('permissions');
//     }
//   };

//   useEffect(() => {
//     const encryptedPermissions = localStorage.getItem('permissions');
//     if (userId) {
//       fetchPermissions();
//     } else if (encryptedPermissions) {
//       const bytes = CryptoJS.AES.decrypt(encryptedPermissions, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
//       const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);
//       if (decryptedPermissionsString) {
//         const permissionsAccess = JSON.parse(decryptedPermissionsString);
//         setPermissionsAccess(permissionsAccess);
//       }
//     }
//   }, [userId, permissionUpdate]);

//   useEffect(() => {
//     if (!userId) {
//       const encryptedData = localStorage.getItem('userid');
//       if (encryptedData) {
//         const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
//         const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
//         setUserId(decryptedUserId);
//       }
//     }
//   }, [userId]);

//   return (
//     <MuiThemeProvider theme={theme}>
//       <ThemeProvider theme={{ 
//         mode, 
//         direction, 
//         shadow, 
//         border,
//          }}
//       >
//         <GlobalStyles />
//         <NotificationStyles />
//         <RechartStyles />
//         <TimepickerStyles />
//         <CalendarStyles />
//         {children}
//       </ThemeProvider>
//     </MuiThemeProvider>
//   );
// };

// ThemeComponent.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// const ConnectedThemeComponent = ThemeComponent;

// const App = () => {
//   useEffect(() => {
//     window.addEventListener('load', initAuth0);
//     return () => window.removeEventListener('load', initAuth0);
//   }, []);

//   return (
//     <AppContextProvider>
//       <Provider store={store}>
//         <BrowserRouter>
//           <ConnectedThemeComponent>
//             <LoadScript loadingElement={<Loading loading />} googleMapsApiKey="">
//               <ScrollToTop>
//                 <Router />
//                 <Chatbot />
//                 <Toaster position="top-right" reverseOrder={false} />
//               </ScrollToTop>
//             </LoadScript>
//           </ConnectedThemeComponent>
//         </BrowserRouter>
//       </Provider>
//     </AppContextProvider>
//   );
// };

// export default App;

